import React, { useEffect, useState } from 'react';
import './NotificationPopup.css';

const NotificationPopup = ({ show, title, message, image, timestamp, onClose }) => {
  const [displayContent, setDisplayContent] = useState({ title: '', body: '' });

  console.log('[NotificationPopup] RAW Props - show:', show, 'title:', title, 'message:', message);

  useEffect(() => {
    if (show) {
      const handleEscape = (e) => {
        if (e.key === 'Escape') onClose();
      };
      document.addEventListener('keydown', handleEscape);
      return () => document.removeEventListener('keydown', handleEscape);
    }
  }, [show, onClose]);

  useEffect(() => {
    if (!show) return;
    
    // Title
    let finalTitle = 'NOTIFICATION';
    if (title) {
      finalTitle = String(title);
    }
    
    // Body
    let finalBody = '';
    if (message) {
      finalBody = String(message);
    }
    
    console.log('[NotificationPopup] Set display - finalTitle:', finalTitle, 'finalBody:', finalBody);
    setDisplayContent({ title: finalTitle, body: finalBody });
  }, [show, title, message]);

  const formatTime = (ts) => {
    if (!ts) return '';
    const date = new Date(ts);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  if (!show) return null;

  return (
    <div className="neon-notif-overlay" onClick={onClose}>
      <div className="neon-notif-container" onClick={(e) => e.stopPropagation()}>
        <div className="neon-notif-glitch-layer"></div>
        <div className="neon-notif-border-glow"></div>
        
        {image && (
          <div className="neon-notif-hero">
            <img src={image} alt="" />
            <div className="neon-notif-hero-overlay"></div>
            <div className="neon-notif-hero-scanline"></div>
          </div>
        )}
        
        <div className="neon-notif-header">
          <div className="neon-notif-icon">
            <div className="neon-notif-icon-ring"></div>
            <i className="fas fa-satellite-dish"></i>
          </div>
          <div className="neon-notif-title-group">
            <span className="neon-notif-label">INCOMING TRANSMISSION</span>
            <h2 className="neon-notif-title">{displayContent.title}</h2>
          </div>
          <button className="neon-notif-close" onClick={onClose}>
            <span></span>
            <span></span>
          </button>
        </div>
        
        <div className="neon-notif-body">
          <div className="neon-notif-body-inner">
            <div className="neon-notif-body-label">
              <i className="fas fa-microchip"></i>
              <span>MESSAGE PAYLOAD</span>
            </div>
            <p className="neon-notif-message">
              {displayContent.body || 'No message content'}
            </p>
          </div>
          
          {timestamp && (
            <div className="neon-notif-timestamp">
              <div className="neon-notif-timestamp-inner">
                <i className="fas fa-clock"></i>
                <span className="neon-notif-time-value">{formatTime(timestamp)}</span>
                <span className="neon-notif-time-label">RECEIVED</span>
              </div>
            </div>
          )}
        </div>
        
        <div className="neon-notif-footer">
          <button className="neon-notif-btn" onClick={onClose}>
            <span className="neon-notif-btn-text">ACKNOWLEDGE</span>
            <span className="neon-notif-btn-line"></span>
          </button>
        </div>
        
        <div className="neon-notif-decor-top">
          <span></span><span></span><span></span><span></span><span></span>
        </div>
        <div className="neon-notif-decor-bottom">
          <span></span><span></span><span></span><span></span><span></span>
        </div>
      </div>
    </div>
  );
};

export default NotificationPopup;